import { SaveState } from '../../../types';

export const combineSaveState = (a: SaveState, b: SaveState): SaveState => {
	if (a === b) {
		return a;
	} else if (a === SaveState.PENDING || b === SaveState.PENDING) {
		return SaveState.PENDING;
	} else if (a === SaveState.FAILURE || b === SaveState.FAILURE) {
		return SaveState.FAILURE;
	} else if (a === SaveState.SUCCESS || b === SaveState.SUCCESS) {
		return SaveState.SUCCESS;
	} else {
		return SaveState.NONE;
	}
};
